<template>
  <h3 :class="computedClass" :style="baseStyle">
    <slot />
  </h3>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { sizeByScreen, getFontSize } from './fontUtils'

interface Props {
  className?: string
}

const props = withDefaults(defineProps<Props>(), {
  className: ''
})

// Calcul des tailles de police pour chaque breakpoint
const baseFontSize = getFontSize('h3')
const mobileMFontSize = getFontSize('h3', sizeByScreen.mobile_m)
const mobileLFontSize = getFontSize('h3', sizeByScreen.mobile_l)
const tabletFontSize = getFontSize('h3', sizeByScreen.tablet)
const laptopFontSize = getFontSize('h3', sizeByScreen.laptop)
const laptopLFontSize = getFontSize('h3', sizeByScreen.laptop_l)
const screen4KFontSize = getFontSize('h3', sizeByScreen['4k_screen'])

const baseStyle = computed(() => ({
  fontSize: baseFontSize,
  lineHeight: '1.5'
}))

const computedClass = computed(() => {
  const classes = ['font-manrope']
  if (props.className) {
    classes.push(props.className)
  }
  return classes.join(' ')
})
</script>

<style scoped>
h3 {
  font-size: v-bind('baseFontSize');
  line-height: 1.5;
}

@media (min-width: 375px) {
  h3 {
    font-size: v-bind('mobileMFontSize');
  }
}

@media (min-width: 425px) {
  h3 {
    font-size: v-bind('mobileLFontSize');
  }
}

@media (min-width: 768px) {
  h3 {
    font-size: v-bind('tabletFontSize');
  }
}

@media (min-width: 1024px) {
  h3 {
    font-size: v-bind('laptopFontSize');
  }
}

@media (min-width: 1440px) {
  h3 {
    font-size: v-bind('laptopLFontSize');
  }
}

@media (min-width: 2560px) {
  h3 {
    font-size: v-bind('screen4KFontSize');
  }
}
</style>
